export default __webpack_public_path__ + "static/media/slider_4-md@2x.ead92da5.jpg";